'use strict';

angular
  .module('checker.data')
  .factory('CheckerData', CheckerData);

CheckerData.$inject = ['$q', '$http', '$timeout', 'API_META'];

function CheckerData($q, $http, $timeout, API_META) {

  var availableDrugs = [],
      availableDrugClassNames = [],
      availableDrugTradeNames = [],
      availableComeds = [],
      availableComedClassNames = [],
      availableComedTradeNames = [],
      availableDrugIndications = [],
      availableInteractions = [];

  return {
    fetchApiDrugs: fetchApiDrugs,
    fetchDrugClassNames: fetchDrugClassNames,
    fetchInteractions: fetchInteractions,
    fetchDrugIndicationsNames: fetchDrugIndicationsNames,
    getComeds: function(){
      return availableComeds;
    },
    getDrugs: function(){
      return availableDrugs;
    },
    getInteractions: function(drugs, comeds, siteType, lang){
      return fetchAvailableInteractions;
    },
    fetchAvailableInteractions: fetchAvailableInteractions,
    fetchAvailableInteractionsByClass: fetchAvailableInteractionsByClass
  };

  function fetchAvailableInteractions(drugs, comeds, siteType, lang){
    var deferred = $q.defer(),
        interactionUrl = siteSpecificUrl(siteType, "_INTERACTION_ENDPOINT") + "_" + lang.toUpperCase();

    if (drugs.length === 0) {
      availableInteractions = []
      deferred.resolve([]);
    } else {
      makeDataRequest(API_META[interactionUrl], 'GET', drugIdParams(drugs, comeds)).then(function(interactions){
        availableInteractions = interactions.data;
        deferred.resolve(interactions.data);
      });
    }

    return deferred.promise;
  }

  function fetchAvailableInteractionsByClass(drugs, drugClassId, siteType, lang){
    var deferred = $q.defer(),
        interactionUrl = siteSpecificUrl(siteType, "_INTERACTION_ENDPOINT") + "_" + lang.toUpperCase();

    if (drugs.length === 0) {
      availableInteractions = []
      deferred.resolve([]);
    } else {
      makeDataRequest(API_META[interactionUrl], 'GET', {...drugIdParams(drugs, []), ...{"drug_class_id": drugClassId}}).then(function(interactions){
        availableInteractions = interactions.data;
        deferred.resolve(interactions.data);
      });
    }

    return deferred.promise;
  }

  /////////////////////////////////////////

  function drugIdParams(drugs, comeds) {
    return {
      "drug_ids[]": drugs.map((drug)=>drug.id), 
      "co_drug_ids[]": comeds.map((drug)=>drug.id)
    }
  }

  function fetchApiDrugs(siteType, lang) {
    var data = [];
    return fetchDrugs(siteType, lang).then(function(drugs){
      availableDrugs = drugs;
      data[0] = drugs;
      return fetchDrugClassNames(siteType, lang).then(function(dClassData) {
        availableDrugClassNames = dClassData;
        data[1] = dClassData;
        return fetchDrugTradeNames(siteType).then(function(dTradeData) {
          availableDrugTradeNames = dTradeData;
          data[2] = dTradeData;
          return fetchComeds(siteType, lang).then(function(comeds) {
            availableComeds = comeds;
            data[3] = comeds;
            return fetchComedClassNames(siteType, lang).then(function(cClassData) {
              availableComedClassNames = cClassData;
              data[4] = cClassData;
              return fetchComedTradeNames(siteType).then(function(cTradeData) {
                availableComedTradeNames = cTradeData;
                data[5] = cTradeData;
                if (siteType === "hep"){
                  return fetchDrugIndicationsNames().then(function(cIndications) {
                    availableDrugIndications = cIndications;
                    data[6] = cIndications;
                    return data;
                  });
                } else {
                  data[6] = []
                  return data;
                }
              });
            });
          });
        });
      });
    });
  }

  function fetchDrugIndicationsNames() {
    if (window.location.href.indexOf("admin") > -1){
      return makeDataRequest(API_META["HEP_ADMIN_INDICATIONS_ENDPOINT"]).then(function(indicationNames){
        return indicationNames.data;
      });
    } else {
      return makeDataRequest(API_META["HEP_INDICATIONS_ENDPOINT"]).then(function(indicationNames){
        return indicationNames.data;
      });
    }
  }

  function fetchComedClassNames(siteType, lang) {
    var comedClassUrl = siteSpecificUrl(siteType, "_COMED_CLASS_NAME_ENDPOINT") + "_" + lang.toUpperCase();
    return makeDataRequest(API_META[comedClassUrl]).then(function(classNames){
      return classNames.data;
    });
  }

  function fetchComedTradeNames(siteType) {
    return makeDataRequest(API_META[siteSpecificUrl(siteType, "_COMED_TRADE_NAMES_ENDPOINT")]).then(function(tradeNames){
      return tradeNames.data;
    });
  }

  function fetchDrugClassNames(siteType, lang) {
    var drugClassUrl = siteSpecificUrl(siteType, "_DRUG_CLASS_NAME_ENDPOINT") + "_" + lang.toUpperCase();
    return makeDataRequest(API_META[drugClassUrl]).then(function(classNames){
      return classNames.data;
    });
  }

  function fetchDrugTradeNames(siteType) {
    return makeDataRequest(API_META[siteSpecificUrl(siteType, "_DRUG_TRADE_NAMES_ENDPOINT")]).then(function(tradeNames){
      return tradeNames.data;
    });
  }

  function fetchComeds(siteType, lang) {
    if (window.location.href.indexOf("admin") > -1){
      return makeDataRequest(API_META[siteSpecificUrl(siteType, "_UNAPPROVED_AND_COMED_ENDPOINT")]).then(function(co_drugs){
        return co_drugs.data;
      });
    } else {
      var comedUrl = siteSpecificUrl(siteType, "_COMED_ENDPOINT") + "_" + lang.toUpperCase();
      return makeDataRequest(API_META[comedUrl]).then(function(co_drugs){
        return co_drugs.data;
      });
    }
  }

  function fetchDrugs(siteType, lang) {
    if (window.location.href.indexOf("admin") > -1){
      return makeDataRequest(API_META[siteSpecificUrl(siteType, "_UNAPPROVED_AND_PRIMARY_ENDPOINT")]).then(function(drugs){
        return drugs.data;
      });
    } else {
      var drugUrl = siteSpecificUrl(siteType, "_DRUG_ENDPOINT") + "_" + lang.toUpperCase();
      return makeDataRequest(API_META[drugUrl]).then(function(drugs){
        return drugs.data;
      });
    }
  }

  function fetchInteractions(siteType, lang){
    var interactionUrl = siteSpecificUrl(siteType, "_INTERACTION_ENDPOINT") + "_" + lang.toUpperCase(); 
    return makeDataRequest(API_META[interactionUrl]).then(function(interactions){
      availableInteractions = interactions.data;
      return interactions.data;
    });
  }

  function makeDataRequest(url, method = 'GET', params = {}) {
    var deferred = $q.defer();

    var req = {
      method: method,
      url: url,
      headers: {
        'Accept': 'application/json;version=3',
        'Content-Type': 'application/json',
        'X-Api-Key': API_META['X-Api-Key']
      },
      params: params
    };

    $http(req).then(function (data) {
      deferred.resolve(data);
    }, function(response){
      deferred.reject(response);
    });

    return deferred.promise;
  }

  function setRequestParams(version, password) {
    var params_object = new SOAPClientParameters();
    if (password === true) {
      params_object.add('password', API_KEYS.PASSWORD);
      params_object.add('dt', version);
      return params_object;
    } else {
      return params_object;
    }
  }

  function siteSpecificUrl(pre, staticPart) {
    return pre.toUpperCase() + staticPart;
  }
}